/*
  Virasat: after a product is added, show a short green confirmation at the top of the
  cart drawer ("✓ Almonds California, 500 g added"), as in TDH-Design-2.
  Listens to Horizon's standard cart event; the drawer itself is opened by cart-drawer.js.
*/
const ADDED_EVENT = 'shopify:cart:lines-update';
const SHOW_FOR_MS = 5000;

document.addEventListener(ADDED_EVENT, async (event) => {
  if (event.action !== 'add' || !event.lines?.length) return;

  try {
    const result = await event.promise;
    if (result?.detail?.didError) return;

    const variantId = String(event.lines[0].merchandiseId).split('/').pop();
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
    const item = cart.items.find((line) => String(line.variant_id) === variantId);
    if (!item) return;

    const name = item.variant_title ? `${item.product_title}, ${item.variant_title}` : item.product_title;

    // Let the drawer's re-render land before the banner is placed
    setTimeout(() => showBanner(name));
  } catch (error) {
    // The banner is a nicety; never let it get in the way of the cart
  }
});

function showBanner(name) {
  const list = document.querySelector('#cart-drawer .cart-drawer__items');
  if (!list) return;

  list.querySelector('.v-cart-added')?.remove();

  const banner = document.createElement('p');
  banner.className = 'v-cart-added';
  banner.setAttribute('role', 'status');
  banner.innerHTML =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg>';
  banner.append(document.createTextNode(`${name} added`));
  list.prepend(banner);

  setTimeout(() => banner.remove(), SHOW_FOR_MS);
}
